document.addEventListener("DOMContentLoaded",() => {
  const imagesDivs = document.getElementsByClassName("ai-images");
  const storedImages = JSON.parse(localStorage.getItem("aiImageURLs")) || [];


  console.log(storedImages)
  console.log(imagesDivs)
  Array.from(imagesDivs).forEach((imagesDiv) => {
   if (storedImages.length > 0) {
    imagesDiv.style.visibility = "visible"
   }

   storedImages.forEach(url => {
      const img = document.createElement("img");
      img.src = url;
      img.alt = "Stored Image";
      imagesDiv.appendChild(img);
   }); 
  });
});